import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Filterable } from '@common/utilities/Filterable';

@Component({
  selector: 'sortable',
  templateUrl: './sortable.component.html',
  styleUrls: ['./sortable.component.scss']
})
export class SortableComponent implements OnInit {

  @Input() target: Filterable<any> = null;
  @Input() sort: 'ascending' | 'descending' = 'ascending';
  @Input() selected: boolean = false;

  @Input() extractor: SortableExtractor<any> = null;

  constructor() { }

  private ascending: (a: any, b: any) => number = null;
  private descending: (a: any, b: any) => number = null;

  private extract(a: any): string | number {
    return this.extractor ? this.extractor.extract(a) : 0;
  }

  ngOnInit() {    

    this.ascending = (a, b) => {

      a = this.extract(a);
      b = this.extract(b);

      if (typeof a == 'string' || typeof b == 'string') {
        return (typeof a == 'string' ? a : a.toString()).localeCompare(typeof b == 'string' ? b : b.toString(), 'vi');
      }
      else {
        return a > b ? 1 : a < b ? -1 : 0;
      }
    }

    this.descending = (a, b) => {

      a = this.extract(a);
      b = this.extract(b);

      if (typeof a == 'string' || typeof b == 'string') {
        return -(typeof a == 'string' ? a : a.toString()).localeCompare(typeof b == 'string' ? b : b.toString(), 'vi');
      }
      else {
        return a > b ? -1 : a < b ? 1 : 0;
      }
    }

    if (this.selected) {
      this.click();
    }
  }

  @HostListener("click") click() {

    if (this.active) {
      switch (this.sort) {
        case 'ascending':

          this.sort = 'descending';
          this.target.sort = this.descending;

          break;
        case 'descending':

          this.sort = 'ascending';
          this.target.sort = this.ascending;

          break;
      }
    }
    else {
      if (this.target != null) {
        this.target.sort = this.sort == 'ascending' ? this.ascending : this.descending;
      }
    }
  }

  public get active() {
    return this.target !== null && (this.target.sort == this.ascending || this.target.sort == this.descending);
  }
}

export interface SortableExtractor<T> {
  extract(item: T): number | string;
}

export abstract class Sortable<T> {
  
  public abstract get target(): Filterable<T>;

  protected abstract extract(field: string, item: T): string | number | void;

  private lu = {};

  public extractor(field: string): SortableExtractor<T> {

    if (!this.lu[field]) this.lu[field] = {
      extract: i => {
        let custom = this.extract(field, i);
        return typeof custom == 'undefined' ? i[field] : custom;
      }
    }

    return this.lu[field];
  }

  public sum(field: string): number {
    let extract = this.extractor(field).extract;
    return !this.target || this.target.empty ? 0 : this.target.matches.sum(i => {
      let test = extract(i);
      return typeof test == 'number' && !isNaN(test) ? test : 0;
    });
  }
}
